import EncryptDecrypt from '@tassat/server-toolkit/src/util/EncryptDecrypt';
import crypto from 'crypto-browserify';

const encryptDecrypt = new EncryptDecrypt(crypto);

export default encryptDecrypt;